module.exports = __webpack_public_path__ + "img/charity_5.db22ab95.png";